import { render, staticRenderFns } from "./PackageAboveTheFold.vue?vue&type=template&id=6af9e373&scoped=true&"
import script from "./PackageAboveTheFold.vue?vue&type=script&lang=ts&"
export * from "./PackageAboveTheFold.vue?vue&type=script&lang=ts&"
import style0 from "./PackageAboveTheFold.vue?vue&type=style&index=0&id=6af9e373&prod&lang=scss&scoped=true&"
import style1 from "./PackageAboveTheFold.vue?vue&type=style&index=1&id=6af9e373&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af9e373",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ClientOnlyPrice: require('/opt/build/repo/apps/shop/components/ClientOnlyPrice.vue').default})
